import { render, staticRenderFns } from "./ReasonDocuments.vue?vue&type=template&id=73ae4df6&scoped=true&"
import script from "./ReasonDocuments.vue?vue&type=script&lang=js&"
export * from "./ReasonDocuments.vue?vue&type=script&lang=js&"
import style0 from "./ReasonDocuments.vue?vue&type=style&index=0&id=73ae4df6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ae4df6",
  null
  
)

export default component.exports